import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {BeroepenPaginaRoutingModule} from './beroepen-pagina-routing.module';
import {BeroepenPaginaAppComponent} from './beroepen-pagina-app.component';
import {ApplicationHttpClient} from './core/application-http-client';
import {HttpClient, HttpHandler, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {ErrorNotifierService} from './core/error-notifier.service';
import {HTTP_CLIENT_WITH_ERROR_HANDLING} from './app.di';
import {OccupationalProfileModule} from './occupationalprofile/occupational-profile.module';

@NgModule({ declarations: [
        BeroepenPaginaAppComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [BeroepenPaginaAppComponent], imports: [BrowserModule,
        BeroepenPaginaRoutingModule,
        OccupationalProfileModule], providers: [
        ErrorNotifierService,
        {
            provide: ApplicationHttpClient,
            useFactory: ApplicationHttpClient.applicationHttpClient,
            deps: [HttpHandler, ErrorNotifierService]
        },
        {
            provide: HTTP_CLIENT_WITH_ERROR_HANDLING,
            useFactory: ApplicationHttpClient.applicationHttpClientWithErrorHandling,
            deps: [HttpHandler, ErrorNotifierService]
        },
        {
            provide: HttpClient,
            useClass: ApplicationHttpClient
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class BeroepenPaginaAppModule {
}
